const workapi = [
    {
        id:1,
        logo: 'fas fa-download',
        title: 'Download App',
        info: 'Lorem ipsum info Lorem ipsum info Lorem ipsum info',
    },
    {
        id:2,
        logo: 'fas fa-chalkboard-teacher',
        title: 'Complete the Instruction',
        info: 'Lorem ipsum info Lorem ipsum info Lorem ipsum info',
    },
    {
        id:3,
        logo: 'fas fa-donate',
        title: 'Receive your funds',
        info: 'Lorem ipsum info Lorem ipsum info Lorem ipsum info',
    },
];

export default workapi;